/**
 * Česká jazyková sada. Klíče tohoto souboru definují kontrakt pro ostatní
 * jazyky (viz `en.ts`) — žádné natvrdo psané texty v komponentách
 * (pozadavky.md kap. 6).
 */
export const cs = {
  'app.title': 'Bits2Schema',
  'app.subtitle': 'Modelování a vizualizace databázových schémat',

  'common.cancel': 'Zrušit',
  'common.back': 'Zpět',
  'common.next': 'Pokračovat',
  'common.close': 'Zavřít',
  'common.delete': 'Smazat',
  'common.open': 'Otevřít',
  'common.create': 'Vytvořit',
  'common.loading': 'Načítám…',
  'common.retry': 'Zkusit znovu',
  'common.yes': 'Ano',
  'common.no': 'Ne',
  'common.never': 'nikdy',
  'common.required': 'povinné',
  'common.unknownError': 'Došlo k neočekávané chybě.',

  'projects.title': 'Projekty',
  'projects.empty': 'Zatím nemáš žádný projekt. Založ ho importem z databáze, nebo jako prázdný.',
  'projects.newFromDatabase': 'Nový projekt z databáze',
  'projects.newEmpty': 'Nový prázdný projekt',
  'projects.column.name': 'Název',
  'projects.column.dialect': 'Dialekt',
  'projects.column.origin': 'Vznik',
  'projects.column.tables': 'Tabulek',
  'projects.column.lastImport': 'Poslední import',
  'projects.column.lastOpened': 'Naposledy otevřeno',
  'projects.column.owner': 'Vlastník',
  'projects.column.actions': 'Akce',
  'projects.origin.import': 'Import z DB',
  'projects.origin.greenfield': 'Prázdný projekt',
  'projects.delete.title': 'Smazat projekt',
  'projects.delete.question':
    'Opravdu smazat projekt „{name}"? Odstraní se projektový soubor i celá jeho historie verzí.',
  'projects.delete.irreversible': 'Akce je nevratná a nelze ji vzít zpět přes undo.',
  'projects.delete.noDbImpact': 'Cílové databáze se smazání nijak nedotkne — mizí jen lokální model.',

  'greenfield.title': 'Nový prázdný projekt',
  'greenfield.description':
    'Prázdný projekt vznikne bez připojení k databázi — jen s volbou SQL dialektu. Připojení lze doplnit kdykoliv později.',
  'greenfield.nameLabel': 'Název projektu',
  'greenfield.dialectLabel': 'SQL dialekt',

  'import.title': 'Nový projekt z databáze',
  'import.step.project': 'Projekt',
  'import.step.connection': 'Připojení',
  'import.step.schemas': 'Schémata',
  'import.step.run': 'Import',
  'import.nameLabel': 'Název projektu',
  'import.dialectLabel': 'SQL dialekt',
  'import.testConnection': 'Test připojení',
  'import.testing': 'Testuji připojení…',
  'import.testOk': 'Připojení funguje. Verze: {version}',
  'import.testOkNoVersion': 'Připojení funguje.',
  'import.testFailed': 'Připojení selhalo: {message}',
  'import.readOnlyHint':
    'Doporučení: pro import použij účet s pouze čtecími oprávněními (read-only role).',
  'import.schemasTitle': 'Vyber schémata k importu',
  'import.schemasHint': 'Importuje se vždy celé vybrané schéma, včetně všech jeho tabulek.',
  'import.schemasEmpty': 'Databáze neobsahuje žádné uživatelské schéma.',
  'import.schemasLoad': 'Načíst schémata',
  'import.schemasNotSupported':
    'Tento dialekt výběr schémat nepoužívá — importuje se celý obsah souboru.',
  'import.start': 'Spustit import',
  'import.running': 'Import probíhá…',
  'import.progress': 'Zpracováno {done} z {total} tabulek',
  'import.progressUnknownTotal': 'Zpracováno {done} tabulek',
  'import.phase.connecting': 'Připojuji se k databázi',
  'import.phase.readingTables': 'Načítám tabulky',
  'import.phase.readingColumns': 'Načítám sloupce',
  'import.phase.readingConstraints': 'Načítám constrainty',
  'import.phase.readingIndexes': 'Načítám indexy',
  'import.phase.buildingModel': 'Sestavuji model',
  'import.phase.savingProject': 'Ukládám projekt',
  'import.phase.done': 'Hotovo',
  'import.failed': 'Import selhal: {message}',
  'import.failedNoModel': 'Model nebyl vytvořen.',
  'import.succeeded': 'Import dokončen.',
  'import.openProject': 'Otevřít projekt',

  'connection.postgres.host': 'Host',
  'connection.postgres.port': 'Port',
  'connection.postgres.database': 'Databáze',
  'connection.postgres.user': 'Uživatel',
  'connection.postgres.password': 'Heslo',
  'connection.postgres.sslMode': 'SSL režim',
  'connection.postgres.sslMode.disable': 'disable — bez šifrování',
  'connection.postgres.sslMode.require': 'require — šifrovat, neověřovat certifikát',
  'connection.postgres.sslMode.verifyFull': 'verify-full — ověřit certifikát i hostname',
  'connection.duckdb.file': 'Soubor databáze',
  'connection.duckdb.filePlaceholder': 'napr. analytics/warehouse.duckdb',
  'connection.duckdb.rootHint': 'Povolený adresář: {root}',
  'connection.duckdb.noFiles':
    'V povoleném adresáři nebyl nalezen žádný DuckDB soubor. Cestu lze zadat i ručně.',
  'connection.duckdb.refresh': 'Načíst soubory znovu',
  'connection.passwordNotice':
    'Heslo se ukládá šifrovaně mimo projektový soubor a nikdy se nezobrazuje v logu.',

  'warnings.title': 'Dílčí problémy importu',
  'warnings.none': 'Import proběhl bez problémů.',
  'warnings.count': 'Počet upozornění: {count}',
  'warnings.column.location': 'Místo',
  'warnings.column.message': 'Popis',
  'warnings.code.unknownType': 'Neznámý typ',
  'warnings.code.permissionDenied': 'Chybí oprávnění',
  'warnings.code.tableSkipped': 'Tabulka vynechána',
  'warnings.code.indexNotRepresentable': 'Index s výrazem',
  'warnings.code.constraintNotRepresentable': 'Nerozřešený constraint',
  'warnings.code.metadataQueryFailed': 'Selhal dotaz na metadata',

  'project.backToList': 'Zpět na projekty',
  'project.dbInfo.button': 'Informace o DB',
  'project.dbInfo.title': 'Informace o databázi',
  'project.summary.tables': 'Tabulky',
  'project.summary.columns': 'Sloupce',
  'project.summary.relations': 'Vazby',
  'project.summary.schemas': 'Schémata',
  'project.connection.title': 'Připojení k databázi',
  'project.connection.none': 'Projekt zatím nemá připojení k databázi.',
  'project.connection.noneHint':
    'Bez připojení nejsou dostupné akce vyžadující reálnou databázi (synchronizace, kontrola aktuálnosti před generováním skriptu). Návrh schématu i generování skriptu proti prázdnému baseline fungují i bez něj.',
  'project.connection.attach': 'Doplnit připojení',
  'project.connection.attached': 'Připojení bylo uloženo.',
  'project.tables.title': 'Importované tabulky',
  'project.tables.empty': 'Projekt zatím neobsahuje žádnou tabulku.',
  'project.tables.column.name': 'Tabulka',
  'project.tables.column.schema': 'Schéma',
  'project.tables.column.columns': 'Sloupce',
  'project.tables.column.pk': 'PK',
  'project.tables.column.fk': 'FK',
  'project.tables.column.indexes': 'Indexy',
  'project.canvasPlaceholder':
    'Projekt zatím neobsahuje žádnou tabulku — canvas se zobrazí po přidání první tabulky.',

  'canvas.saveNow': 'Uložit',
  'canvas.saveStatus.idle': '',
  'canvas.saveStatus.saving': 'Ukládám…',
  'canvas.saveStatus.saved': 'Uloženo',
  'canvas.saveStatus.error': 'Uložení se nezdařilo',

  // Epic 13 — undo/redo zásobník.
  'undo.button': 'Zpět',
  'redo.button': 'Vpřed',
  'undo.tooltip': 'Zpět: {description}',
  'redo.tooltip': 'Vpřed: {description}',

  // Epic 7 — layout algoritmy a vedení vazeb.
  'canvas.autoLayout.button': 'Auto-layout',
  'canvas.autoLayout.confirmTitle': 'Přepočítat rozložení celého schématu?',
  'canvas.autoLayout.confirmMessage':
    'Přepočítají se pozice všech tabulek i trasy všech vazeb — veškeré ruční úpravy rozložení a ručně vedených tras se zahodí. Před provedením se vytvoří checkpoint v historii, akci lze vrátit i přes Ctrl+Z.',
  'canvas.autoLayout.confirmAction': 'Přepočítat rozložení',
  'canvas.fk.resetRoute': 'Resetovat trasu',
  'history.checkpoint.beforeAutoLayout': 'Před auto-layoutem',

  // Epic 2 — synchronizace s DB.
  'sync.button': 'Synchronizovat',
  'sync.title': 'Synchronizace s databází',
  'sync.phase.computingDiff': 'Počítám rozdíly',
  'sync.noDifferences': 'Model odpovídá aktuálnímu stavu databáze.',
  'sync.selectAllAddedChanged': 'Vybrat vše přidané/změněné',
  'sync.merge.action': 'Sloučit vybrané',
  'sync.applying': 'Slučuji vybrané změny…',
  'sync.done.baselineOnly': 'Nic se strukturálně nezměnilo, baseline byl aktualizován.',
  'sync.done.merged': 'Sloučeno položek: {count}. Baseline byl aktualizován.',
  'sync.confirmRemoval.title': 'Odebrat vybrané položky z modelu?',
  'sync.confirmRemoval.question':
    'Vybráno k odebrání: {count} položek, které v databázi už neexistují. Akci nejde vzít zpět přes Ctrl+Z — vrátit se dá jen přes obnovení starší verze v historii.',
  'sync.confirmRemoval.tableInGroup': 'Tabulka „{name}" je členem skupiny „{group}" — po odebrání z ní bude vyřazena.',
  'sync.confirmRemoval.tableHasNotes': 'K tabulce „{name}" je připnuto poznámek: {count} — budou smazány.',
  'sync.confirmRemoval.hint': 'Ostatní ruční úpravy canvasu (pozice, barvy) merge nemění.',
  'history.checkpoint.manualSync': 'Ruční synchronizace',

  // Epic 9 — generování change skriptů.
  'changeScript.button': 'Generovat change script',
  'changeScript.title': 'Change script',
  'changeScript.noBaseline': 'Projekt zatím nemá žádnou baseline (poslední známý stav DB).',
  'changeScript.lastSync': 'Poslední sync proběhl: {time}',
  'changeScript.lastSyncNever': 'Ještě neproběhl žádný sync s databází.',
  'changeScript.conflicts.intro': 'Nalezeny konflikty: {count}. U každého vyber, jestli chceš přijmout aktuální stav z databáze, nebo zachovat svou změnu.',
  'changeScript.conflicts.baseline': 'Poslední známý stav',
  'changeScript.conflicts.db': 'Aktuálně v databázi',
  'changeScript.conflicts.model': 'Aktuálně v modelu',
  'changeScript.conflicts.acceptDb': 'Přijmout stav z DB',
  'changeScript.conflicts.keepMine': 'Zachovat mou změnu',
  'changeScript.conflicts.continue': 'Pokračovat',
  'changeScript.preflight.continue': 'Sloučit a pokračovat',
  'changeScript.preflight.baselineLabel': 'Pre-flight před generováním change scriptu',
  'changeScript.finalDiff.empty': 'Model odpovídá poslednímu známému stavu databáze — není co generovat.',
  'changeScript.generateButton': 'Vygenerovat skript',
  'changeScript.generating': 'Generuji skript…',
  'changeScript.result.summary': 'Skript vygenerován — obsahuje příkazů: {count}.',
  'changeScript.result.copy': 'Kopírovat',
  'changeScript.result.download': 'Stáhnout .sql',
  'changeScript.result.ranIt': 'Skript jsem spustil → synchronizovat',
  'history.trigger.changeScriptGenerated.viewScript': 'Zobrazit skript',
  'history.changeScript.title': 'Vygenerovaný change script',

  // Epic 12 — export do statické HTML dokumentace.
  'export.button': 'Exportovat do HTML',
  'export.documentTitle': '{name} — dokumentace schématu',
  'export.generatedAt': 'Vygenerováno {time}',
  'export.diagram.title': 'Diagram',
  'export.documentation.title': 'Dokumentace tabulek',
  'export.freeNotes.title': 'Volné poznámky',
  'export.notes.fromGroup': 'Poznámka ke skupině „{name}"',
  'export.index.unique': 'unikátní',
  'export.column.header.name': 'Sloupec',
  'export.column.header.type': 'Typ',
  'export.column.header.nullable': 'Nullable',
  'export.column.header.default': 'Výchozí hodnota',
  'export.column.header.key': 'Klíč',
  'export.column.header.comment': 'DB komentář',
  'export.column.header.notes': 'Poznámky',
  'export.column.key.primary': 'PK',
  'export.column.key.foreign': 'FK',
  'export.column.key.both': 'PK, FK',

  'canvas.group.createFromSelection': 'Seskupit',
  'canvas.group.createTitle': 'Nová skupina',
  'canvas.group.renameTitle': 'Přejmenovat skupinu',
  'canvas.group.rename': 'Přejmenovat',
  'canvas.group.renameHint': 'Dvojklikem přejmenovat skupinu',
  'canvas.group.dissolve': 'Zrušit skupinu',
  'canvas.group.removeTable': 'Odebrat ze skupiny',
  'canvas.group.addTable': 'Přidat do skupiny „{name}"',
  'canvas.group.nameLabel': 'Název skupiny',
  'canvas.group.defaultName': 'Nová skupina',

  'canvas.note.addToTable': 'Přidat poznámku k tabulce',
  'canvas.note.addToColumn': 'Přidat poznámku ke sloupci',
  'canvas.note.addToGroup': 'Přidat poznámku ke skupině',
  'canvas.note.addFree': 'Přidat poznámku',
  'canvas.note.unpin': 'Odepnout',
  'canvas.note.pinTo': 'Připnout k…',
  'canvas.note.pinToTable': 'Připnout k tabulce „{name}"',
  'canvas.note.pinToGroup': 'Připnout ke skupině „{name}"',
  'canvas.note.countTooltip': 'Počet poznámek: {count}',
  'canvas.note.placeholder': 'Text poznámky…',

  // Epic 5 — vizuální editor FK vazeb (drag&drop mezi sloupci na canvasu).
  'canvas.fk.typeMismatch': 'Vazbu nelze vytvořit: sloupec „{source}" a „{target}" mají neslučitelné typy.',
  'canvas.fk.compositeReconnectUnsupported':
    'Kompozitní vazbu (víc sloupcových párů) lze přepojit jen formulářem v inspektoru.',
  'canvas.fk.deleteEdge': 'Smazat vazbu',

  'canvas.table.colorButton': 'Barva tabulky',

  'canvas.column.nullable': 'NULL',
  'canvas.column.notNullable': 'NOT NULL',

  // Epic 8 — přepínání pohledů (DB schéma / ER diagram).
  'canvas.viewSettings.button': 'Zobrazení',
  'canvas.viewSettings.presetDbSchema': 'DB schéma pohled',
  'canvas.viewSettings.presetErDiagram': 'ER diagram pohled',
  'canvas.viewSettings.onlyKeyColumns': 'Zobrazit jen klíčové sloupce',
  'canvas.viewSettings.showColumnType': 'Datový typ sloupce',
  'canvas.viewSettings.showNullable': 'Nullable indikátor',
  'canvas.viewSettings.showDefault': 'Výchozí hodnota',
  'canvas.viewSettings.showComment': 'Komentář sloupce',
  'canvas.viewSettings.showCardinalityLabel': 'Štítek kardinality na vazbě',

  'canvas.color.none': 'Bez barvy',
  'canvas.color.slate': 'Břidlicová',
  'canvas.color.red': 'Červená',
  'canvas.color.orange': 'Oranžová',
  'canvas.color.amber': 'Jantarová',
  'canvas.color.green': 'Zelená',
  'canvas.color.teal': 'Petrolejová',
  'canvas.color.blue': 'Modrá',
  'canvas.color.indigo': 'Indigová',
  'canvas.color.violet': 'Fialová',
  'canvas.color.pink': 'Růžová',

  'canvas.command.moveTable': 'přesun tabulky',
  'canvas.command.moveGroup': 'přesun skupiny',
  'canvas.command.recolorTable': 'změna barvy tabulky',
  'canvas.command.createGroup': 'vytvoření skupiny „{name}"',
  'canvas.command.renameGroup': 'přejmenování skupiny na „{name}"',
  'canvas.command.dissolveGroup': 'zrušení skupiny „{name}"',
  'canvas.command.addTableToGroup': 'přidání tabulky do skupiny',
  'canvas.command.removeTableFromGroup': 'odebrání tabulky ze skupiny',
  'canvas.command.createNote': 'vytvoření poznámky',
  'canvas.command.editNoteText': 'úprava textu poznámky',
  'canvas.command.moveNote': 'přesun poznámky',
  'canvas.command.deleteNote': 'smazání poznámky',
  'canvas.command.pinNote': 'změna připnutí poznámky',
  'canvas.command.clearTableCanvasState': 'úklid canvas metadat smazané tabulky',
  'canvas.command.autoLayout': 'automatický auto-layout',
  'canvas.command.placeTable': 'automatické umístění tabulky',
  'canvas.command.updateEdgeRoute': 'úprava trasy vazby',
  'canvas.command.resetEdgeRoute': 'reset trasy vazby',

  'theme.toggleToLight': 'Přepnout na světlý režim',
  'theme.toggleToDark': 'Přepnout na tmavý režim',
  'language.switchTo': 'Přepnout jazyk na {language}',
  'language.cs': 'čeština',
  'language.en': 'angličtina',

  'workspace.tree.title': 'Navigace',
  'workspace.tree.searchPlaceholder': 'Hledat tabulku nebo sloupec…',
  'workspace.tree.empty': 'Schéma zatím neobsahuje žádnou tabulku.',
  'workspace.tree.noMatches': 'Ničemu neodpovídá „{query}".',
  'workspace.tree.columnsTooltip': 'Počet sloupců: {count}',
  'workspace.panel.collapse': 'Sbalit panel',
  'workspace.panel.expand': 'Rozbalit panel',

  'inspector.title': 'Vlastnosti',
  'inspector.empty': 'Vyber tabulku, sloupec, skupinu nebo poznámku pro zobrazení detailu.',
  'inspector.section.comment': 'Komentář v databázi',
  'inspector.section.notes': 'Poznámky',
  'inspector.comment.empty': 'Bez komentáře.',
  'inspector.notes.empty': 'Zatím žádné poznámky.',
  'inspector.notes.add': 'Přidat poznámku',
  'inspector.table.title': 'Tabulka',
  'inspector.table.schema': 'Schéma',
  'inspector.table.nameLabel': 'Název tabulky',
  'inspector.table.duplicateName': 'Název „{name}" už v tomto schématu existuje.',
  'inspector.table.columnsTitle': 'Sloupce ({count})',
  'inspector.table.addColumn': 'Přidat sloupec',
  'inspector.table.detailTitle': 'Constrainty a indexy',
  'inspector.table.primaryKey': 'Primární klíč',
  'inspector.table.foreignKeys': 'Cizí klíče',
  'inspector.table.addForeignKey': 'Přidat cizí klíč',
  'inspector.table.uniqueConstraints': 'Unikátní omezení',
  'inspector.table.uniqueTitle': 'Unikátní omezení ({count})',
  'inspector.table.addUnique': 'Přidat unikátní omezení',
  'inspector.table.checkConstraints': 'Check omezení',
  'inspector.table.checkTitle': 'Check omezení ({count})',
  'inspector.table.addCheck': 'Přidat check omezení',
  'inspector.table.indexes': 'Indexy',
  'inspector.table.addIndex': 'Přidat index',
  'inspector.table.edit': 'Upravit',
  'inspector.table.none': '—',
  'inspector.table.deleteButton': 'Smazat tabulku',
  'inspector.table.deleteConfirmTitle': 'Smazat tabulku „{name}"?',
  'inspector.table.deleteConfirmBlocked':
    'Tabulku nelze smazat — odkazují na ni cizí klíče: {list}. Nejprve je odstraň nebo přesměruj.',
  'inspector.table.deleteConfirmQuestion':
    'Tabulka i její canvas metadata (pozice, barva) budou odstraněny.',
  'inspector.table.deleteConfirmWarningGroup': 'Tabulka je členem skupiny „{name}" — po smazání z ní bude odebrána.',
  'inspector.table.deleteConfirmWarningNotes': 'K tabulce nebo jejím sloupcům je připnuto poznámek: {count} — budou smazány.',
  'inspector.column.title': 'Sloupec',
  'inspector.column.nameLabel': 'Název sloupce',
  'inspector.column.duplicateName': 'Název „{name}" už v této tabulce existuje.',
  'inspector.column.type': 'Typ',
  'inspector.column.typeCustom': 'Vlastní / neznámý typ',
  'inspector.column.typeCustomPlaceholder': 'např. varchar(255)',
  'inspector.column.typeParamLength': 'Délka',
  'inspector.column.typeParamPrecision': 'Přesnost',
  'inspector.column.typeParamScale': 'Škála',
  'inspector.column.rawTypeHint': 'Typ v DB: {rawType}',
  'inspector.column.nullable': 'Nullable',
  'inspector.column.default': 'Výchozí hodnota',
  'inspector.column.isPrimaryKey': 'Součást primárního klíče',
  'inspector.column.isForeignKey': 'Součást cizího klíče',
  'inspector.column.deleteButton': 'Smazat sloupec',
  'inspector.column.deleteConfirmTitle': 'Smazat sloupec „{name}"?',
  'inspector.column.deleteBlocked': 'Sloupec je součástí cizího klíče „{name}" — nejprve ho uprav nebo smaž.',
  'inspector.column.deletePkWarning':
    'Tohle je jediný sloupec primárního klíče — po smazání zůstane tabulka bez PK.',
  // Epic 5 — detail FK vazby vybrané na canvasu (klik na hranu).
  'inspector.foreignKey.columns': 'Sloupce',
  'inspector.foreignKey.references': 'Odkazuje na',
  'inspector.foreignKey.onDelete': 'ON DELETE',
  'inspector.foreignKey.onUpdate': 'ON UPDATE',
  'inspector.foreignKey.cardinality': 'Kardinalita',
  'inspector.foreignKey.editCardinalityShortcut': 'Upravit unikátní omezení sloupce',

  'inspector.group.title': 'Skupina',
  'inspector.group.nameLabel': 'Název skupiny',
  'inspector.group.membersTitle': 'Tabulky ve skupině ({count})',
  'inspector.note.title': 'Poznámka',
  'inspector.note.attachedToTable': 'Připnuto k tabulce „{name}"',
  'inspector.note.attachedToColumn': 'Připnuto ke sloupci „{name}"',
  'inspector.note.attachedToGroup': 'Připnuto ke skupině „{name}"',
  'inspector.note.free': 'Volná poznámka',

  'schema.validation.emptyName': 'Název nesmí být prázdný.',
  'schema.table.addAction': 'Přidat tabulku',

  'schema.type.category.numeric': 'Číselné',
  'schema.type.category.text': 'Textové',
  'schema.type.category.binary': 'Binární',
  'schema.type.category.boolean': 'Booleovské',
  'schema.type.category.datetime': 'Datum a čas',
  'schema.type.category.uuid': 'UUID',
  'schema.type.category.structured': 'Strukturované',
  'schema.type.category.network': 'Síťové',
  'schema.type.category.spatial': 'Prostorové',
  'schema.type.category.other': 'Ostatní',
  'schema.type.reason.empty': 'Datový typ nesmí být prázdný.',
  'schema.type.reason.unknownType': 'Neznámý typ „{detail}".',
  'schema.type.reason.parameterRequired': 'Typ „{detail}" vyžaduje parametr.',
  'schema.type.reason.parameterNotAllowed': 'Typ „{detail}" parametry nepřijímá.',
  'schema.type.reason.parameterInvalid': 'Typ „{detail}" má neplatné parametry.',

  'schema.command.addTable': 'přidání tabulky „{name}"',
  'schema.command.deleteTable': 'smazání tabulky „{name}"',
  'schema.command.renameTable': 'přejmenování tabulky „{from}" na „{to}"',
  'schema.command.updateTableComment': 'úprava komentáře tabulky',
  'schema.command.addColumn': 'přidání sloupce „{name}"',
  'schema.command.deleteColumn': 'smazání sloupce „{name}"',
  'schema.command.moveColumn': 'přesun sloupce „{name}"',
  'schema.command.renameColumn': 'přejmenování sloupce „{from}" na „{to}"',
  'schema.command.updateColumn': 'úprava sloupce',
  'schema.command.setPrimaryKey': 'úprava primárního klíče',
  'schema.command.addUniqueConstraint': 'přidání unikátního omezení „{name}"',
  'schema.command.updateUniqueConstraint': 'úprava unikátního omezení „{name}"',
  'schema.command.deleteUniqueConstraint': 'smazání unikátního omezení „{name}"',
  'schema.command.addCheckConstraint': 'přidání check omezení „{name}"',
  'schema.command.updateCheckConstraint': 'úprava check omezení „{name}"',
  'schema.command.deleteCheckConstraint': 'smazání check omezení „{name}"',
  'schema.command.addForeignKey': 'přidání cizího klíče „{name}"',
  'schema.command.updateForeignKey': 'úprava cizího klíče „{name}"',
  'schema.command.deleteForeignKey': 'smazání cizího klíče „{name}"',
  'schema.command.addIndex': 'přidání indexu „{name}"',
  'schema.command.updateIndex': 'úprava indexu „{name}"',
  'schema.command.deleteIndex': 'smazání indexu „{name}"',

  'schema.dialog.unique.createTitle': 'Nové unikátní omezení',
  'schema.dialog.unique.editTitle': 'Upravit unikátní omezení',
  'schema.dialog.unique.nameLabel': 'Název',
  'schema.dialog.unique.columnsLabel': 'Sloupce',
  'schema.dialog.unique.columnsRequired': 'Vyber alespoň jeden sloupec.',

  'schema.dialog.check.createTitle': 'Nové check omezení',
  'schema.dialog.check.editTitle': 'Upravit check omezení',
  'schema.dialog.check.nameLabel': 'Název',
  'schema.dialog.check.expressionLabel': 'Výraz podmínky',
  'schema.dialog.check.expressionEmpty': 'Výraz nesmí být prázdný.',
  'schema.dialog.check.expressionUnbalanced': 'Závorky ve výrazu nejsou vyvážené.',

  'schema.dialog.index.createTitle': 'Nový index',
  'schema.dialog.index.editTitle': 'Upravit index',
  'schema.dialog.index.nameLabel': 'Název',
  'schema.dialog.index.columnsLabel': 'Sloupce (v pořadí)',
  'schema.dialog.index.uniqueLabel': 'Unikátní',
  'schema.dialog.index.addColumn': 'Přidat sloupec',
  'schema.dialog.index.columnsRequired': 'Vyber alespoň jeden sloupec.',
  'schema.dialog.index.remove': 'Odebrat',
  'schema.dialog.index.moveUp': 'Posunout nahoru',
  'schema.dialog.index.moveDown': 'Posunout dolů',

  'schema.dialog.fk.createTitle': 'Nová vazba cizího klíče',
  'schema.dialog.fk.editTitle': 'Upravit vazbu cizího klíče',
  'schema.dialog.fk.nameLabel': 'Název',
  'schema.dialog.fk.targetTableLabel': 'Cílová tabulka',
  'schema.dialog.fk.onDeleteLabel': 'ON DELETE',
  'schema.dialog.fk.onUpdateLabel': 'ON UPDATE',
  'schema.dialog.fk.pairsLabel': 'Sloupce (zdroj → cíl)',
  'schema.dialog.fk.sourceColumnLabel': 'Zdrojový sloupec',
  'schema.dialog.fk.targetColumnLabel': 'Cílový sloupec',
  'schema.dialog.fk.addPair': 'Přidat pár sloupců',
  'schema.dialog.fk.removePair': 'Odebrat',
  'schema.dialog.fk.pairsRequired': 'Přidej alespoň jeden pár sloupců.',
  'schema.dialog.fk.duplicateSourceColumn': 'Zdrojový sloupec „{name}" je použit vícekrát.',
  'schema.dialog.fk.incompleteRow': 'Vyber zdrojový i cílový sloupec pro každý pár.',
  'schema.dialog.fk.typeMismatch':
    'Zdrojový sloupec „{source}" ({sourceType}) a cílový „{target}" ({targetType}) nemají kompatibilní typ.',
  'schema.dialog.fk.targetNotKeyWarning':
    'Cílové sloupce nejsou součástí primárního klíče ani unikátního omezení cílové tabulky — vazba i tak vznikne, ale ověř, že to je záměr.',

  'history.openButton': 'Historie',
  'history.title': 'Historie verzí',
  'history.createCheckpoint': 'Vytvořit checkpoint',
  'history.checkpointLabelPlaceholder': 'Popisek (volitelné)',
  'history.empty': 'Historie zatím neobsahuje žádný záznam.',
  'history.column.trigger': 'Typ',
  'history.column.time': 'Čas',
  'history.column.author': 'Autor',
  'history.column.label': 'Popisek',
  'history.column.tables': 'Tabulek',
  'history.column.actions': 'Akce',
  'history.trigger.checkpoint': 'Checkpoint',
  'history.trigger.dbSync': 'Sync s DB',
  'history.trigger.changeScriptGenerated': 'Vygenerován skript',
  'history.trigger.revert': 'Obnovení verze',
  'history.revert.action': 'Obnovit',
  'history.revert.confirmTitle': 'Obnovit tuto verzi?',
  'history.revert.confirmQuestion':
    'Aktuální stav modelu (struktura i canvas) se přepíše obsahem záznamu z {time}.',
  'history.revert.confirmHint':
    'Nic v historii se nesmaže — vznikne nový záznam typu „Obnovení verze" na jejím konci.',
  'history.revert.confirm': 'Obnovit verzi',
  'history.diff.title': 'Porovnat verze',
  'history.diff.from': 'Verze A',
  'history.diff.to': 'Verze B',
  'history.diff.show': 'Zobrazit rozdíl',
  'history.diff.empty': 'Mezi vybranými verzemi není žádný strukturální rozdíl.',
  'history.diff.column.object': 'Objekt',
  'history.diff.column.path': 'Cesta',
  'history.diff.column.old': 'Původní hodnota',
  'history.diff.column.new': 'Nová hodnota',
  'history.diff.changeType.added': 'přidáno',
  'history.diff.changeType.changed': 'změněno',
  'history.diff.changeType.removed': 'odebráno',
  'history.diff.changeType.renamed': 'přejmenováno',
  'history.diff.objectType.table': 'tabulka',
  'history.diff.objectType.column': 'sloupec',
  'history.diff.objectType.primaryKey': 'primární klíč',
  'history.diff.objectType.foreignKey': 'cizí klíč',
  'history.diff.objectType.uniqueConstraint': 'unikátní omezení',
  'history.diff.objectType.checkConstraint': 'check omezení',
  'history.diff.objectType.index': 'index',

  'error.validationFailed': 'Zadané údaje nejsou platné.',
  'error.notFound': 'Požadovaná položka neexistuje.',
  'error.connectionFailed': 'Připojení k databázi se nezdařilo.',
  'error.importFailed': 'Import se nezdařil.',
  'error.syncFailed': 'Synchronizace s databází se nezdařila.',
  'error.unsupportedDialect': 'Zvolený SQL dialekt není podporován.',
  'error.fileNotFound': 'Soubor neexistuje nebo není čitelný.',
  'error.pathNotAllowed': 'Cesta míří mimo povolený adresář.',
  'error.notImplemented': 'Tato funkce zatím není implementovaná.',
  'error.internalError': 'Chyba na straně serveru.',
  'error.unauthorized': 'Přihlášení je vyžadováno.',
  'error.invalidCredentials': 'Neplatné uživatelské jméno nebo heslo.',
  'error.forbidden': 'K této akci nemáš oprávnění.',
  'error.usernameTaken': 'Uživatelské jméno je již obsazené.',
  'error.editLeaseHeld': 'Projekt právě edituje jiný uživatel.',

  // Epic 14 — uživatelé a oprávnění.
  'auth.login.title': 'Přihlášení',
  'auth.login.usernameLabel': 'Uživatelské jméno',
  'auth.login.passwordLabel': 'Heslo',
  'auth.login.submit': 'Přihlásit se',
  'auth.logout': 'Odhlásit se',
  'auth.loggedInAs': 'Přihlášen jako {name}',

  'users.button': 'Uživatelé',
  'users.title': 'Uživatelé',
  'users.column.username': 'Uživatelské jméno',
  'users.column.displayName': 'Zobrazované jméno',
  'users.create.title': 'Nový uživatel',
  'users.create.usernameLabel': 'Uživatelské jméno',
  'users.create.displayNameLabel': 'Zobrazované jméno',
  'users.create.passwordLabel': 'Heslo',
  'users.create.submit': 'Vytvořit uživatele',
  'users.create.success': 'Uživatel „{name}" byl vytvořen.',

  'password.change.button': 'Změnit heslo',
  'password.change.title': 'Změna hesla',
  'password.change.currentLabel': 'Současné heslo',
  'password.change.newLabel': 'Nové heslo',
  'password.change.submit': 'Změnit heslo',
  'password.change.success': 'Heslo bylo změněno.',

  'project.editors.title': 'Editoři',
  'project.editors.creatorLabel': 'Creator: {name}',
  'project.editors.empty': 'Projekt zatím nemá žádné editory.',
  'project.editors.addPlaceholder': 'Vyber uživatele…',
  'project.editors.add': 'Přidat editora',
  'project.editors.remove': 'Odebrat',
  'project.editors.transferButton': 'Převést vlastnictví',
  'project.editors.transferTitle': 'Převést vlastnictví projektu?',
  'project.editors.transferQuestion':
    'Vlastnictví projektu „{project}" se převede na uživatele „{user}". Ty se staneš editorem a ztratíš právo projekt mazat nebo správovat editory a vlastnictví.',
  'project.editors.transferConfirm': 'Převést vlastnictví',
  'project.editors.transferNoEditors':
    'Vlastnictví lze převést jen na existujícího editora — nejdřív někoho přidej jako editora.',
  'project.role.creator': 'Creator',
  'project.role.editor': 'Editor',

  'lease.readOnlyBanner': '„{name}" právě edituje (poslední aktivita před {seconds} s) — projekt je jen k náhledu.',
  'lease.takeoverButton': 'Převzít editaci',
  'lease.takenOverNotice': 'Editaci převzal uživatel „{name}" — dokud si ji znovu nenárokuješ, nejde ukládat.',

  // Epic 15 — rozšíření možností projektů.
  'project.rename.nameLabel': 'Název projektu',
  'project.rename.save': 'Uložit název',
  'project.rename.saved': 'Název projektu uložen.',

  'canvas.tools.button': 'Nástroje',

  'createScript.button': 'Generovat create script',
  'createScript.title': 'Čistý create script',
  'createScript.description':
    'Vygeneruje kompletní create script pro celý aktuální model — jako by šel do zcela prázdné databáze. Nebere v potaz poslední baseline ani dosavadní change scripty.',
  'createScript.schemaNameLabel': 'Vlastní název cílového schématu (nepovinné)',
  'createScript.schemaNameHint':
    'Dostupné jen u projektů s jedním schématem — u projektu s víc schématy se script vygeneruje s původními názvy.',
  'createScript.generateButton': 'Vygenerovat',
  'createScript.generating': 'Generuji skript…',
  'createScript.empty': 'Model zatím neobsahuje žádné objekty ke generování.',
  'createScript.result.summary': 'Skript vygenerován — obsahuje příkazů: {count}.',
  'createScript.result.copy': 'Kopírovat',
  'createScript.result.download': 'Stáhnout .sql',

  'projects.duplicate.button': 'Vytvořit kopii',
  'projects.duplicate.title': 'Vytvořit kopii projektu',
  'projects.duplicate.nameLabel': 'Název kopie',
  'projects.duplicate.defaultName': '{name} (kopie)',
  'projects.duplicate.hint':
    'Kopie vznikne jako nezávislý projekt — bez historie verzí originálu a bez připojení k databázi. Připojení lze doplnit později stejně jako u prázdného projektu.',
  'projects.duplicate.confirm': 'Vytvořit kopii',

  'inspector.column.moveUp': 'Posunout nahoru',
  'inspector.column.moveDown': 'Posunout dolů',
} as const;

export type MessageKey = keyof typeof cs;
